import script from "./PersonLinkageRoot.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonLinkageRoot.vue?vue&type=script&setup=true&lang=js"

import "./PersonLinkageRoot.vue?vue&type=style&index=0&id=2ba1653c&lang=scss"

const __exports__ = script;

export default __exports__